import { useState, useEffect } from "react";

interface Props {
  value: string;
  delay: number;
}

export const useDebounce = ({ value, delay }: Props) => {
  const [query, setQuery] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setQuery(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return query;
};
